import {
  Box, Button, Grid, Stack,
} from '@mui/material';
import { useMemo } from 'react';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import BlockProps from '../../../models/BlockProps';
import Utils from '../../../utils/Utils';
import CloseButton from '../../Buttons/Close';
import BlockTextListData from './BlockTextListData';
import SubBlockText from './SubBlockText';
import BlockTextListColumnData from './BlockTextListColumnData';
import styles from './BlockTextList.module.css';

function BlockTextList({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockTextListData);

  const handleAddColumn = () => {
    props.columns.push(BlockTextListColumnData.getDefault());
    editHandler(data.id, props);
  };

  const columns = useMemo(() => {
    if (props.columns && props.columns.length > 0) {
      return props.columns.map((column, colIndex) => {
        const currentColumn = props.columns[colIndex].data;
        return (
          <Grid
            key={column.id}
            item
            xs={6}
            sx={[Utils.hoverBorder(isEditing), { padding: 2 }]}
            alignItems="center"
            justifyContent="center"
            className={styles.textItem}
          >
            <CloseButton
              show={isEditing}
              updateHandler={() => {
                props.columns.splice(colIndex, 1);
                editHandler(data.id, props);
              }}
            />

            {column.data.map((item, index) => {
              const currentSubBlock = currentColumn[index];
              return (
                <SubBlockText
                  key={item.id}
                  isEditing={isEditing}
                  isTemplate={isTemplate}
                  data={item}
                  onTitleUpdate={(newTitle) => {
                    currentSubBlock.title.value = newTitle;
                    editHandler(data.id, props);
                  }}
                  onTextUpdate={(newText) => {
                    currentSubBlock.text.value = newText;
                    editHandler(data.id, props);
                  }}
                  onSubBlockDelete={() => {
                    currentColumn.splice(index, 1);
                    editHandler(data.id, props);
                  }}
                  onTextDelete={() => {
                    currentSubBlock.text.value = undefined;
                    editHandler(data.id, props);
                  }}
                  onTitleDelete={() => {
                    currentSubBlock.title.value = undefined;
                    editHandler(data.id, props);
                  }}
                />
              );
            })}

          </Grid>
        );
      });
    }

    return [];
  }, [data.id, editHandler, isEditing, props, isTemplate]);

  return (
    <Grid
      container
      spacing={0}
      alignItems="start"
      justifyContent="start"
      sx={{
        minHeight: '250px',
        overflow: 'hidden',
        padding: 2,
      }}
    >
      <Box className={styles.listsContainer}>
        {columns}
      </Box>
      {isEditing && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', marginTop: '12px', width: '100%' }}>
          <Button color="primary" onClick={handleAddColumn}>
            <AddCircleRoundedIcon />
          </Button>
        </Stack>
      )}
    </Grid>
  );
}

export default BlockTextList;
